import * as React from "react"
import styled, { css } from "styled-components"
import { ButtonLink } from "styleguide/components/Button"
import { Container } from "styleguide/components/grid"
import { IconBurger, IconClose } from "styleguide/icons"
import MobileDropdown from "./MobileMenuDropdown"
import MobileMenuItem from "./MobileMenuItem"
import MobileNavContext, { MobileNavContextType } from "./MobileNavContext"

const StyledButton = styled(ButtonLink)`
  display: block;
  text-align: center;
`

const StyledMobileMenu = styled.div<{ isOpen: boolean }>`
  display: none;
  position: fixed;
  height: 100%;
  top: 86px;
  background: white;
  z-index: 100;
  width: 100%;
  left: 0;
  padding-top: 80px;
  padding-bottom: 20px;
  height: calc(100% - 86px);
  overflow: scroll;

  ${(props) =>
    props.isOpen &&
    css`
      display: block !important;
    `}
`

const StyledIconBurger = styled(IconBurger)`
  height: 24px;
  width: 24px;
`

const StyledIconClose = styled(IconClose)`
  height: 20px;
  width: 20px;
`

const MobileMenu = () => {
  const [isOpen, setIsOpen] = React.useState(false)

  const mobileNavContextPayload: MobileNavContextType = {
    isOpen,
    onClose: () => setIsOpen(false),
  }

  const showMenu = () => {
    setIsOpen(true)
  }

  const closeMenu = () => {
    setIsOpen(false)
  }

  return (
    <MobileNavContext.Provider value={mobileNavContextPayload}>
      {!isOpen && <StyledIconBurger onClick={showMenu} />}
      {isOpen && <StyledIconClose onClick={closeMenu} />}
      <StyledMobileMenu isOpen={isOpen}>
        <Container>
          <MobileMenuItem
            title="About"
            content={
              <MobileDropdown>
                <MobileMenuItem
                  isSubMenuItem
                  title="About us"
                  linkTo="/about/"
                />
                <MobileMenuItem
                  isSubMenuItem
                  title="Client engagement model"
                  linkTo="/blog/client-engagement-model/"
                />
                <MobileMenuItem
                  isSubMenuItem
                  title="We're hiring"
                  linkTo="/career/"
                />
              </MobileDropdown>
            }
          />
          <MobileMenuItem
            title="Services"
            content={
              <MobileDropdown>
                <MobileMenuItem
                  isSubMenuItem
                  title="What we do"
                  linkTo="/services/"
                />
                <MobileMenuItem isSubMenuItem title="Design" linkTo="/design" />
                <MobileMenuItem
                  isSubMenuItem
                  title="React on Rails Pro"
                  linkTo="/react-on-rails-pro/"
                />
                <MobileMenuItem
                  isSubMenuItem
                  title="Web Scraping & Data Analysis"
                  linkTo="/services/web-scraping-and-data-analysis"
                />
                <MobileMenuItem
                  isSubMenuItem
                  title="AI Consulting"
                  linkTo="/services/ai-consulting"
                />
                <MobileMenuItem
                  isSubMenuItem
                  title="IT Infrastructure Optimization"
                  linkTo="/services/it-infrastructure-optimization"
                />
              </MobileDropdown>
            }
          />
          <MobileMenuItem
            title="Portfolio"
            content={
              <MobileDropdown>
                <MobileMenuItem
                  isSubMenuItem
                  title="Recent work"
                  linkTo="/recent-work/"
                />
                <MobileMenuItem
                  isSubMenuItem
                  title="HiChee.com"
                  linkTo="/hichee/"
                />
                <MobileMenuItem
                  isSubMenuItem
                  title="Open Source Projects"
                  linkTo="/open-source-projects/"
                />
              </MobileDropdown>
            }
          />
          <MobileMenuItem
            title="Insights"
            content={
              <MobileDropdown>
                <MobileMenuItem isSubMenuItem title="Blog" linkTo="/blog/" />
                <MobileMenuItem
                  isSubMenuItem
                  title="Forum"
                  linkTo="https://forum.shakacode.com"
                  externalLink
                />
                <MobileMenuItem isSubMenuItem title="Talks" linkTo="/talks/" />
              </MobileDropdown>
            }
          />
          <MobileMenuItem
            title="Docs"
            content={
              <MobileDropdown>
                <MobileMenuItem
                  isSubMenuItem
                  title="React on Rails"
                  linkTo="/react-on-rails/docs/"
                />
                <MobileMenuItem
                  isSubMenuItem
                  title="React on Rails Pro"
                  linkTo="/react-on-rails-pro/docs/"
                />
                <MobileMenuItem
                  isSubMenuItem
                  title="Control Plane flow"
                  linkTo="/control-plane-flow/docs/"
                />
              </MobileDropdown>
            }
          />
          <StyledButton href="https://meetings.hubspot.com/justingordon/30-minute-consultation">
            Book a Free Call
          </StyledButton>
        </Container>
      </StyledMobileMenu>
    </MobileNavContext.Provider>
  )
}

export default MobileMenu
